export default __webpack_public_path__ + "static/media/igloo.3b81529b.jpg";